import React, { useContext } from 'react'
import classnames from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'

import { getApplyCtaText } from 'components/Search/utils'

import zIndex from 'styles/tools/z-index'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import OccupancyPicker from 'components/Common/OccupancyPicker/OccupancyPicker'
import config from 'constants/config'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Dropdown = styled.div`
  box-shadow: ${props => props.theme.shadow.flat.small};
  display: none;
  position: absolute;
  top: calc(100% + ${rem(8)});
  border-radius: ${props => props.theme.borderRadius.medium};
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.palette.neutral.eight};
  z-index: ${zIndex.menu};

  &.toggled {
    display: block;
  }

  &.map-view {
      ${mediaQueryUp.largeDesktop} {
      max-width: ${rem(1000)};
      left: calc((100% - ${rem(1000)}) / 2);
    }
  }

  > * + * {
    margin-top: ${rem(20)}
  }
`

interface Props {
  rooms: App.Occupants[];
  isToggled: boolean;
  onRoomChange: (rooms: Array<App.Occupants>) => void;
  onRoomsApply: () => void;
  closeMenu: () => void;
  isLastStep?: boolean;
  saleUnit?: string;
  isMapView?: boolean;
}

function SearchTravellersDropdown({ isToggled, rooms, onRoomChange, onRoomsApply, isLastStep, saleUnit, isMapView = false }: Props) {
  const { disableMultiRoom, disableSaleUnit } = useContext(GlobalSearchStateContext)
  return (
    <Dropdown className={classnames({ toggled: isToggled, 'map-view': isMapView })}>
      <OccupancyPicker
        saleUnit={saleUnit}
        occupancies={rooms}
        onChange={onRoomChange}
        onApply={onRoomsApply}
        applyText={getApplyCtaText(isLastStep)}
        submit
        enableMultiRoom={disableMultiRoom ? false : config.accommodation.allowsMultiRoom}
        disableSaleUnit={disableSaleUnit}
      />
    </Dropdown>
  )
}

export default SearchTravellersDropdown
